// extracted by mini-css-extract-plugin
module.exports = {"form-col":"index_form-col__Q48gc"};